import apiSlice from "./apiSlice";

const riskeDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        
        // Get Risk KPI
        getRiskKPI: builder.query({
            query: (params) => ({
                url: `risk/dashboard/kpis`,
                params
            }),
            providesTags: ["Get-Risk-KPI"],
        }),

        // Get Top Critical Risk
        getTopCriticalRisk: builder.query({
            query: (params) => ({
                url: `risk/dashboard/top-high-risks`,
                params
            }),
            providesTags: ["Get-Top-Critical-Risk"],
        }),

        // Get Risk Trend Graph
        getRiskTrend: builder.query({
            query: (params) => ({
                url: `risk/dashboard/risk-trends`,
                params
            }),
            providesTags: ["Get-Risk-Trend"],
        }),

        // Get Risk Distribution Graph
        getRiskDistribution: builder.query({
            query: (params) => ({
                url: `risk/dashboard/risk-by-package`,
                params
            }),
            providesTags: ["Get-Risk-Distribution"],
        }),

        // Get Active Risk Severity Graph
        getActiveRiskSeverity: builder.query({
            query: (params) => ({
                url: `risk/dashboard/severity-count`,
                params
            }),
            providesTags: ["Get-Active-Risk-Severity"],
        }),

        // Get Risk Heat matrix Graph
        getRiskHeatMatrix: builder.query({
            query: (params) => ({
                url: `risk/dashboard/heat-matrix`,
                params
            }),
            providesTags: ["Get-Risk-Heat-Matrix"],
        }),
        
        // Get All Risk Graph Click
        getAllRiskOpenClose: builder.query({
            query: ({ endpoint = 'Risk', ...params }) => ({
                url: endpoint,
                params
            }),
            providesTags: ["Get-All-Risk-Graph-Click"],
        }),

    }),
});

export default riskeDashboardSlice;

export const {
    useGetRiskKPIQuery, useGetTopCriticalRiskQuery, useGetRiskTrendQuery, 
    useGetRiskDistributionQuery, useGetActiveRiskSeverityQuery, useGetRiskHeatMatrixQuery,
    useGetAllRiskOpenCloseQuery,

} = riskeDashboardSlice;